export const CONTACT_INFO = {
  phone: '2 714 714 int. 12102',
  email: 'cpap@fing.edu.uy',
  address: 'Julio Herrera y Reissig 565',
  linkedin:
    'https://www.linkedin.com/school/centro-de-posgrados-y-actualizaci%C3%B3n-profesional-en-inform%C3%A1tica/about/',
  bussinessHours: 'Lunes a viernes de 18 a 21 hs.',
};
